import { useId } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../utils/toastMessage/toastMessage";
import { uploadUserService } from "../../services/userServices";
import { validateFile } from "../../utils";

const UploadMedia = ({ callback }) => {
  const id = useId();

  const dispatch = useDispatch();

  // Upload File
  const handleUploadFile = async (file) => {
    const fileErrorMessage = validateFile(file);
    if (fileErrorMessage) return toastErrorMessage(fileErrorMessage);

    const objData = { file };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await uploadUserService(objData);
      if (status === 200) {
        callback && callback(data.result);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <label htmlFor={id} className="btn btn-primary w-100 py-3 text-white">
      بارگذاری تصویر
      <input
        type="file"
        multiple
        id={id}
        className="d-none"
        accept="image/jpg,image/png,image/jpeg"
        onChange={(e) => {
          const file = e.target.files[0];
          handleUploadFile(file);
        }}
      />
    </label>
  );
};

export default UploadMedia;
